import { ApplicationInsights, ITelemetryItem } from '@microsoft/applicationinsights-web';
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';
import { Constants } from '../Variables/StaticVariables';

const reactPlugin = new ReactPlugin();
const appInsights = new ApplicationInsights({
    config: {
        connectionString: Constants.appInsightsInstrumentationKey,
        extensions: [reactPlugin],
        enableAutoRouteTracking: true,
        disableAjaxTracking: false,
        autoTrackPageVisitTime: true,
        enableCorsCorrelation: true,
        enableRequestHeaderTracking: true,
        enableResponseHeaderTracking: true,
    }
});

if (Constants.appInsightsInstrumentationKey) {
    appInsights.loadAppInsights();

    console.log('App Insights loaded', appInsights.config);

    appInsights.addTelemetryInitializer((env: ITelemetryItem) => {
        env.tags = env.tags || [];
        env.tags["ai.cloud.role"] = document.location.hostname;
    });
}
export { reactPlugin, appInsights };